import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/order-queue")({
  component: lazyRouteComponent(() => import("./-pages/admin.order-queue")),
  head: () => ({
    meta: [
      { title: "طابور معالجة الطلبات · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
